import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import type { LexicalNode } from "lexical";
import { useCallback } from "react";

export const useGetElementRect = (): ((node: LexicalNode) => DOMRect | null) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    (node: LexicalNode): DOMRect | null => {
      const element = editor.getElementByKey(node.getKey());
      if (element) {
        return element.getBoundingClientRect();
      }
      return null;
    },
    [editor],
  );
};
